"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axios = void 0;
var axios_1 = __importDefault(require("axios"));
var Axios;
(function (Axios) {
    /**
     * Axios 요청 인스턴스
     * @param data 타입 가급적 명세
     * @returns
     */
    Axios.Client = function (_a) {
        var header = _a.header, _b = _a.method, method = _b === void 0 ? 'post' : _b, url = _a.url, _c = _a.responseType, responseType = _c === void 0 ? 'json' : _c, params = _a.params, data = _a.data, _d = _a.cancelToken, cancelToken = _d === void 0 ? null : _d;
        var headers = header;
        if (!headers.token)
            delete headers.token;
        if (!headers.language)
            delete headers.language;
        if (!headers.isRemake)
            delete headers.isRemake;
        if (!headers.uuid)
            delete headers.uuid;
        if (!headers.mature)
            delete headers.mature;
        if (!headers.is17)
            delete headers.is17;
        if (!headers.isAlreadyMature)
            delete headers.isAlreadyMature;
        var requestConfig = {
            method: method,
            url: url,
            responseType: responseType,
            headers: headers,
            data: data,
            params: params,
            cancelToken: cancelToken,
        };
        if (cancelToken === null) {
            delete requestConfig.cancelToken;
        }
        return axios_1.default.request(requestConfig);
    };
    /**
     * 관리자용 axios object
     * @param param0
     * @returns
     */
    Axios.Manager = function (_a) {
        var header = _a.header, _b = _a.method, method = _b === void 0 ? 'post' : _b, url = _a.url, _c = _a.responseType, responseType = _c === void 0 ? 'json' : _c, params = _a.params, data = _a.data, _d = _a.cancelToken, cancelToken = _d === void 0 ? null : _d, _e = _a.progressCallback, progressCallback = _e === void 0 ? null : _e;
        var headers = header;
        var requestConfig = {
            method: method,
            url: url,
            responseType: responseType,
            headers: headers,
            data: data,
            params: params,
        };
        if (cancelToken !== null) {
            requestConfig.cancelToken = cancelToken;
        }
        if (progressCallback !== null) {
            requestConfig.onUploadProgress = progressCallback;
        }
        return axios_1.default.request(requestConfig);
    };
})(Axios = exports.Axios || (exports.Axios = {}));
